import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MultaRepository } from '@app/data/multas/multa.repository';
import { ApiResources } from '@constants/api-resources';

@Component({
  selector: 'app-add-condutor-contrato',
  templateUrl: './add-condutor-contrato.component.html',
  styleUrls: ['./add-condutor-contrato.component.scss']
})
export class AddCondutorContratoComponent {
  condutorContrato: any;
  temCondutorContrato: boolean = false;
  showLoadBar: boolean = true;
  constructor(
    private _dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) private data: { codigoMulta: string },
    private multaRepository: MultaRepository,
  ) { }

  async ngOnInit() {
    await this.getCondutorContrato();
  }

  async getCondutorContrato() {
    this.multaRepository.basePath = ApiResources.MULTAS_CONDUTOR_CONTRATO;
    this.multaRepository.getRequest<any>({ codigoMulta: this.data.codigoMulta }).subscribe(({ data }) => {
      if (data) {
        this.condutorContrato = data;
        if (this.condutorContrato.nomeCondutor !== null)
          this.temCondutorContrato = true;
        this.multaRepository.basePath = ApiResources.MULTAS;
      }
    });
  }

  putCondutorMulta() {
    let body = {
      codigoMulta: this.data.codigoMulta,
      codigoCondutor: this.condutorContrato.codigoCondutor,
      nomeCondutor: this.condutorContrato.nomeCondutor,
      cpf: this.condutorContrato.cpf
    };

    this.multaRepository.basePath = ApiResources.MULTAS_CONDUTOR;
    this.multaRepository.putRequest<any>('', body).subscribe(() => {
      this.close();
      this.multaRepository.basePath = ApiResources.MULTAS;
    });
  }

  close() {
    this._dialogRef.close();
  }
}
